export enum GmcFilterTypes {
  ONLY_SECTION,
  ONLY_POSITION,
  SECTION_AND_POSITION
}



// WEBPACK FOOTER //
// ./app/shared/components/gmc-cv-filter/gmc-cv-filter-types.ts